@if (isLoading) {
<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>

<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
}
@else {
<div class="margin-above" [ngClass]="{'dialog-view-wrapper-empty': filteredConnections.length === 0}">

  <ng-container *ngIf="filteredConnections.length > 0; then lastConnections else noConnections"> </ng-container>

  <ng-template #lastConnections>

    <h2 class="panel-title">{{('Modules.RemoteMaintenance.Connections.LastConnectionDetails' | translate)}}</h2>
    <div class="details-card">

      <!-- Duration -->
      <div>
        <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.Connections.Duration' | translate }}</h4>
        <div class="detail-value">{{ getDurationString(filteredConnections[0]) }}</div>
      </div>

      <!-- StartTime -->
      <div *ngIf="filteredConnections[0].startUtc">
        <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.Connections.StartTime' | translate }}</h4>
        <div class="detail-value">{{ ((filteredConnections[0].startUtc | localizedDate: 'short') ||
          ('General.NotAvailableShort' | translate)) }}</div>
      </div>

      <!-- EndTime -->
      <div>
        <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.Connections.EndTime' | translate }}</h4>
        <div class="detail-value">{{ ((filteredConnections[0].endUtc | localizedDate: 'short') ||
          ('General.NotAvailableShort' | translate)) }}</div>
      </div>

      <!-- MaskedIpAddress -->
      <div>
        <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.Connections.MaskedIpAddress' | translate }}</h4>
        <div class="detail-value">{{ (filteredConnections[0].maskedIpAddress) || ('General.NotAvailableShort' |
          translate) }}</div>
      </div>

      <!-- Connection method -->
      <div>
        <h4 class="detail-type">{{ 'Modules.RemoteMaintenance.Connections.InterfaceMode' | translate }}</h4>
        <div class="detail-value">{{ getInterfaceModeString() }}</div>
      </div>
    </div>

    <h2 class="panel-title">{{('Modules.RemoteMaintenance.Connections.ConnectionHistory' | translate)}}</h2>
    <app-list-item *ngFor="let log of filteredConnections| slice:1;" title="{{ getDurationString(log) }}"
      info="{{ ((log.startUtc | localizedDate: 'short') || ('General.NotAvailableShort' | translate)) + ' - ' + ((log.endUtc | localizedDate: 'short') || ('General.NotAvailableShort' | translate)) + ' - ' + log.maskedIpAddress}}"
      [showActionIcon]="false">
    </app-list-item>
  </ng-template>

  <ng-template #noConnections>
    <div class="panel-no-data">{{ 'Modules.RemoteMaintenance.Connections.NoConnections' | translate }}</div>
  </ng-template>
</div>
}